import styled from 'styled-components';

export const CollectionGradientWrapper = styled.div`
  position: relative;
  isolation: isolate;
  height: 100%;
  width: 100%;
  border-radius: var(--double-unit);
  transition: transform 0.2s ease-in-out;

  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: inherit;
    inset: -1px;
    background: var(--c-nd-150);
    z-index: -2;
  }

  &.complete {
    &::after {
      filter: blur(5px);
    }
    &::before,
    &::after {
      background: var(--completed-color);
    }
  }
  &.hoverable {
    &:hover {
      transform: scale(1.02);
    }
  }
`;
